<div class="innerBanner" style="background-image: url('{{ bannerImage }}')" (click)="imageClick(0)">
  <div class="bannerText">
    <h1>{{ islandsDetails.islandCatName }}</h1>
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<!-- <app-breadcrumb></app-breadcrumb> -->
<app-breadcrumb-row></app-breadcrumb-row>
<div class="container">
  <div class="form-row">
    <div class="container contentPanel col-md-12">
      <div class="pageTitle">
        <h1>{{ islandsDetails.bannerTitle }}</h1>
      </div>
      <p-carousel
        [value]="islandsDetails.gallery"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="false"
        [responsiveOptions]="responsiveOptions"
        class="islandDetailsimage"
      >
        <ng-template pTemplate="header"> </ng-template>
        <ng-template let-product pTemplate="item">
          <div class="product-item">
            <div class="product-item-content">
              <div class="p-mb-3"></div>
              <div>
                <h4 class="p-mb-1">{{ product.title }}</h4>
                <div class="product-item-content">
                  <div class="image">
                    <img
                      [src]="product.url ? product.url : '../../../assets/images/NoImage.jpg'"
                      [alt]="product.name"
                      class="product-image slider-image"
                    />
                  </div>
                  <div class="title">
                    <small>{{ product.title }}</small>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
      <ul class="list-group mb-2">
        <li class="list-group-item">
          <b>{{ 'Population' | translate }} :</b>{{ islandsDetails.population }}
        </li>
        <li class="list-group-item">
          <b>{{ 'Island group' | translate }} :</b>{{ islandsDetails.group }}
        </li>
        <li class="list-group-item">
          <b>{{ 'Area' | translate }} :</b> {{ islandsDetails.area }}
        </li>
        <li class="list-group-item">
          <b>{{ 'Island Hopping Possibilities' | translate }} :</b>{{ islandsDetails.hopingPossibilities }}
        </li>
      </ul>

      <b>{{ 'Description' | translate }} : </b>
      <p [innerHTML]="islandsDetails.content"></p>
      <p>&nbsp;</p>
    </div>
    <div class="col-md-6"></div>
  </div>
</div>
